<script>
import {
  CdrSkeleton,
  CdrSkeletonBone,
} from '@rei/cedar';

import {
  CdrSpaceThreeQuarterX, CdrBreakpointLg, CdrBreakpointMd,
} from '@rei/cdr-tokens';

export default {
  name: 'FilmStripLoader',
  components: {
    CdrSkeleton,
    CdrSkeletonBone,
  },
  props: {
    slidesNumber: { type: Number, default: 5 },
  },
  data() {
    return {
      containerWidth: 0,
      slidesGap: 12,
      slidesToShow: 4,
    };
  },
  computed: {
    slideWidth() {
      const slideGap = parseInt(CdrSpaceThreeQuarterX, 10);
      const slidesGapTotal = this.slidesToShow * slideGap;
      const slidesWidthWithoutGaps = this.containerWidth - slidesGapTotal;
      const slidesToShowCount = this.slidesToShow + 0.25;
      return slidesWidthWithoutGaps / slidesToShowCount;
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
  },
  unmounted() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      if (this.$refs.filmStripLoader) {
        this.containerWidth = this.$refs.filmStripLoader?.offsetWidth ?? 0;
      }

      const { clientWidth } = window.document.body;

      switch (true) {
        case clientWidth >= Number(CdrBreakpointLg):
          this.slidesToShow = 4;
          break;
        case clientWidth >= Number(CdrBreakpointMd):
          this.slidesToShow = 3;
          break;
        default:
          this.slidesToShow = 2;
      }
    },
  },
};
</script>
<template>
  <div
    class="film-strip-loader"
  >
    <cdr-skeleton>
      <div class="film-strip-loader__heading">
        <cdr-skeleton-bone type="heading" />
      </div>
      <div ref="filmStripLoader">
        <div class="film-strip-loader__cards">
          <div class="film-strip-loader__cards-container">
            <ul class="film-strip-loader__cards-list">
              <li
                v-for="index in slidesNumber"
                :key="index"
                class="film-strip-loader__card-item"
              >
                <div class="film-strip-loader__card">
                  <cdr-skeleton-bone
                    type="rectangle"
                    class="film-strip-loader__card-skeleton"
                  />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </cdr-skeleton>
  </div>
</template>
<style lang="scss" scoped>
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

.film-strip-loader {
  --slides-gap: v-bind(slidesGap);
  --slide-width: v-bind(slideWidth);
  position: relative;

  &__heading {
    height: $cdr-text-body-500-height;
    margin-bottom: $cdr-space-one-x;
  }

  &__cards {
    overflow: hidden;
  }

  &__cards-container {
    min-width: fit-content;
  }

  &__cards-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-auto-columns: calc(var(--slide-width)* 1px);
    grid-template-rows: auto;
    grid-auto-flow: column;
    gap: calc(var(--slides-gap)* 1px);
    margin-top: $cdr-space-one-x;
    margin-bottom: $cdr-space-one-and-a-half-x;
  }

  &__card-item {
    width: 100%;
  }

  &__card {
    aspect-ratio: 3 / 4;
    border-radius: 8px;
  }

  &__card-skeleton {
    height: 100%;
  }
}
</style>
